import createInlineButtons from './inline-buttons';
import createInsertButtons from './insert-buttons';
export default function createToolbar(_a) {
    var helpers = _a.helpers, t = _a.t, pluginConfig = _a.pluginConfig;
    return {
        InlineButtons: createInlineButtons({ pluginConfig: pluginConfig, helpers: helpers }),
        InsertButtons: createInsertButtons({ helpers: helpers, t: t }),
        name: 'gallery',
    };
}
//# sourceMappingURL=createToolbar.js.map